enum AccessKeyActionType {
  Loan = 'Loan',
  Reservation = 'Reservation',
  ReservationCancellation = 'ReservationCancellation',
  Return = 'Return',
}

export default AccessKeyActionType;
